import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
    <h2 className="text-4xl sm:text-5xl font-medium leading-[1.05] tracking-tight">{title}</h2>
    {sub && <p className="mt-6 text-base md:text-lg text-white/70 font-light leading-relaxed">{sub}</p>}
  </Reveal>
);

export const PageHero = ({ eyebrow, title, sub, testid }) => (
  <section className="relative overflow-hidden bg-[#0A0A0A] pt-40 pb-20 md:pt-48 md:pb-28" data-testid={testid}>
    <div className="absolute -top-40 -right-32 w-[520px] h-[520px] rounded-full bg-[#5D2E8C]/30 blur-[120px]" />
    <div className="absolute bottom-0 left-0 right-0 gold-rule opacity-40" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="eyebrow mb-6">{eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight max-w-4xl">{title}</h1>
        {sub && <p className="mt-8 max-w-2xl text-base md:text-lg text-white/70 font-light leading-relaxed">{sub}</p>}
      </Reveal>
    </div>
  </section>
);
